import { createSelector } from '@ngrx/store';
import {
  selectCurrentLanguage,
  translateFeature,
  TranslateStoreState,
} from '../reducers/translate.reducers';
import { AuthUserProfileStore } from '@arc/arc-shared-frontend';

export const selectLanguageCode = createSelector(
  translateFeature.selectTranslateState,
  (state: TranslateStoreState) => {
    return state.currentLanguage.replace('-', '_');
  },
);

export const selectLanguageInPadServiceFormat = createSelector(
  selectCurrentLanguage,
  (currentLanguage) => {
    if (currentLanguage?.includes('-')) {
      return (
        currentLanguage.slice(0, -2) + currentLanguage.slice(-2).toUpperCase()
      );
    }
    return currentLanguage;
  },
);

export const selectUserProfileLanguage = createSelector(
  AuthUserProfileStore,
  (userProfile) => {
    return userProfile?.defaultLanguage;
  },
);
